import customHeaders, { getSpace } from '../../../common/headers';
import useGeneralStore from '../../../store/general';
import close_icon from './img/close_icon(members).svg';
import { ModalAddTask } from '../../ComponentsCommonTasksLogic/ModalAddTask/ModalAddTask';
import { ModalNewTaskList } from '../../../components/Modal/ModalNewTaskList/ModalNewTaskList';
import { ModalAddExecutor } from '../../ComponentsCommonTasksLogic/Modal/ModalAddExecutor/ModalAddExecutor';
import { ModalListExecutor } from '../../ComponentsCommonTasksLogic/Modal/ModalListExecutor/ModalListExecutor';
import { ModalTaskStatus } from '../../../components/Modal/ModalTaskStatus/ModalTaskStatus';
import { ExecutorPlaceholder } from '../../../components/OptionsExecutor/OptionsExecutor';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { RavshanHttp, RavshanHttps } from '../../../fetchUrls';
import { fromSnakeCase, toSnakeCase } from '../../../common/mappers';
import {
  ViewSwitch,
  ButtonBasic,
  DropDownSelector,
  InputDynamicWidth,
  Checkbox,
  TableBox,
  Tabs,
  NotActive,
  Tooltip
} from '@lk-gtcom/ecomlab-components';
import { Route, Routes } from 'react-router-dom';
import { useDataTable } from '../../../common/hooks';
import { Loader } from '../../../common/components/Loader/Loader';
import ChatModal from '../../../components/Modal/ChatModal/ChatModal';
import { useState, useEffect, useMemo, Fragment, useRef, useCallback } from 'react';
import { BordTask } from '../../ComponentsCommonTasksLogic/BoardLogic/BordTask/BordTask';
import './TaskList.scss';
import {
  addFiltersByDataObj,
  addFiltersToUrlQuery,
  getFiltersByUrlQuery,
  getDataObjByFilters,
} from '../../../common/utils';
import { ColumnTask } from '../../ComponentsCommonTasksLogic/ColumnTask/ColumnTask';
import { MoonLoader } from 'react-spinners';
import { ButtonTelegramm } from '../../../components/Buttons/ButtonTelegramm/ButtonTelegramm';
import { ButtonsSort } from '../../../components/Buttons/BurronsSort/ButtonsSort';
import { Main } from '../../Main/Main';
import { MainDirectory } from '../../MainDirectory/MainDirectory';
import { CheckList } from '../../../components/CheckList/CheckList';
import { ButtonWithIcon } from '../../../components/Buttons/ButtonWithIcon/ButtonWithIcon';
import { usePushNotifications } from '../../../common/pushNotification';
import { StepItem } from '../../../components/StepItem/StepItem';
import { useDebounce } from '../../../hooks/useDebounce';
import { useResponseHandler } from '../../../common/auth';
import ModalWarning from '../../../components/Modal/ModalWarning/ModalWarning';

// Иконки
import add_user from './img/account.svg'

const parse = require('html-react-parser');
export const TASK_EVENT_TYPE = 'Задача';

// Константы
const task_permissible = [
  'В РАБОТЕ',
  'ГОТОВО',
  'НА ПРОВЕРКЕ',
  'НА СТОПЕ',
  'НОВЫЕ ЗАДАЧИ',
];

const btn_sort = [
  { label: 'A-Z', value: 'name' },
  { label: 'По дате создания', value: 'date' },
  { label: 'По приоритету', value: 'priority' },
];

const FETCH_DELAY_MS = 1000;

const TaskListInner = ({ setSelectedProjectAbove }) => {
  // Refs
  const refTable = useRef();
  const refHeader = useRef();
  const refContainer = useRef();
  const refScrollbar = useRef();
  const refTaskBox = useRef();
  const refBoard = useRef();
  const refsTotal = useRef([]);
  const paginatorRef = useRef();
  const containerRef = useRef();
  const tableContainerRef = useRef();

  // Навигация и параметры
  const navigate = useNavigate();
  const path = useParams()['*'];
  const [searchParams, setSearchParams] = useSearchParams();

  // Store и заголовки
  const selectedSpace = useGeneralStore((state) => state.selectedSpace);
  const headers = { ...customHeaders, ...getSpace(selectedSpace) };
  const { handleTableResponse, handleRequestError } = useResponseHandler();

  // Пользовательские данные
  const client_id = localStorage.getItem('client_id');
  const email = localStorage.getItem('email');
  const eventId = sessionStorage.getItem('eventId');

  // Состояния для модальных окон
  const [isModal, setIsModal] = useState(false);
  const [isChatModal, setIsChatModal] = useState(false);
  const [showModalNewTaskList, setShowModalNewTaskList] = useState(false);
  const [showModalAddMember, setShowModalAddMember] = useState(false);
  const [isModalDeleteCol, setIsModalDeleteCol] = useState(false);
  const [isModalListExecutor, setIsModalListExecutor] = useState(false);
  const [isModalStatus, setIsModalStatus] = useState(false);
  const [isModalExit, setIsModalExit] = useState(false);

  // Состояния для данных
  const [tokenWiki, setTokenWiki] = useState(null);
  const [wikiId, setWikiId] = useState(null);
  const [fileId, setFileId] = useState(null);
  const [taskId, setTaskId] = useState(null);
  const [projectName, setProjectName] = useState(sessionStorage.getItem('taskProjectName'));
  const [infoTask, setInfoTask] = useState(false);
  const [removableTaskList, setRemovableTaskList] = useState('');
  const [selectedColumn, setSelectedColumn] = useState();

  // Состояния для фильтров и поиска
  const [selectedExecutor, setSelectedExecutor] = useState([]);
  const [selectedCoExecutor, setSelectedCoExecutor] = useState([]);
  const [selectedAuthor, setSelectedAuthor] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [searchValue, setSearchValue] = useState('');
  const [currentSort, setCurrentSort] = useState(null);
  const [sort1, setSort1] = useState(null);

  // Состояния для данных проектов и задач
  const [tasks, setTasks] = useState([]);
  const [prevTasks, setPrevTasks] = useState([]);
  const [columns, setColumns] = useState([]);
  const [author, setAuthor] = useState(null);
  const [projectAttendees, setProjectAttendees] = useState([]);
  const [projectPreview, setProjectPreview] = useState([]);
  const [selectedProjectPreview, setSelectedProjectPreview] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);

  // Состояния загрузки
  const [load, setLoad] = useState(false);
  const [loadTotal, setLoadTotal] = useState(true);
  const [loadTotalCount, setLoadTotalCount] = useState(false);
  const [isLoadInfoTask, setIsLoadInfoTask] = useState(false);
  const [columnsAreUpdating, setColumnsAreUpdating] = useState(true);
  const [columnNameIsUpdating, setColumnNameIsUpdating] = useState(false);

  // Состояния для drag & drop
  const [actual, setActualElement] = useState(undefined);
  const [draggableColumn, setDraggableColumn] = useState('');
  const [columnDragStarted, setColumnDragStarted] = useState(false);
  const [isOver, setIsOver] = useState(false);

  // Состояния для UI
  const [selectView, setSelectView] = useState('Tile-long');
  const [isShowAllExecutor, setIsShowAllExecutor] = useState(false);
  const [isOpenActiveMenu, setIsOpenActiveMenu] = useState(false);
  const [isRead, setIsRead] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [isShowAuthor, setIsShowAuthor] = useState(false);
  const [isEditCol, setIsEditCol] = useState(false);
  const [isBlockKey, setIsBlockKey] = useState(false);
  const [isOpen, setIsOpen] = useState(true);

  // Состояния для позиционирования и скролла
  const [positionElement, setPositionElement] = useState(0);
  const [bottom, setBottom] = useState(0);
  const [leftPosition, setLeftPosition] = useState(0);
  const [isFixed, setIsFixed] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [widthTaskList, setWidthTaskList] = useState(0);
  const [widtContainer, setWidtContainer] = useState(0);

  // Состояния для обновления данных
  const [isUpdateDataColumn, setIsUpdateColumn] = useState(false)
  const [updateCol, setUpdateCol] = useState(false);
  const [isNew, setIsNew] = useState(false);
  const [actualId, setActualId] = useState(-1);
  const [updateId, setUpdateId] = useState(-1);
  const [iniitalQuery, setInitialQuery] = useState(true);

  // Состояния для таблицы
  const [setTable, tableProps, setTableFuncs] = useDataTable(
    paginatorRef.current?.setTotal,
    paginatorRef
  );

  const [tableData, setTableData] = useState([]);
  const { setLoading, setFetchedData, setHeaders, setSorte } = setTableFuncs;
  const { filters, sort } = tableProps

  // Состояния для счетчиков
  const [totalTaskGeneral, setTotalTaskGeneral] = useState(0);
  const [isUpdateTotal, setIsUpdateTotal] = useState(false);
  const [generalTotal, setGeneralTotal] = useState(0);
  const [countCol, setCountCol] = useState(0);
  const [totalEvent, setTotalEvent] = useState(0);
  const [totalProject, setTotalProject] = useState(0);

  // Состояния для досок
  const [currentBord, setCurrentBord] = useState(null);
  const [bordListLength, setBordListLength] = useState(0);
  const [currentColumn, setCurrentColumn] = useState(null);

  // Состояния для печати
  const [isVisibleCheckbox, setIsVisibleCheckbox] = useState(false);
  const [listPrint, setListPrint] = useState([]);

  // Состояния для навигации по табам
  const [pageValue, setPageValue] = useState('');
  const activeTab = useParams()['*'];

  // Состояния для доступа
  const [isAccess, setIsAccess] = useState(false);
  const [isAccessProject, setIsAccessProject] = useState(false);

  // Другие состояния
  const [query, setQuery] = useState('');
  const [currPrjoect, setCurrPrjoect] = useState(false);
  const [idTable, setIdTable] = useState('');
  const [pathsWebName, setPathsWebName] = useState('');
  const [paths, setPaths] = useState('');

  // Обработка ошибок
  const { addErrorPush, addSuccessPush } = usePushNotifications();

  // Конфигурация табов
  const btn_tab = [
    { label: 'Проект', value: `${taskId}` },
    { label: 'Wiki', value: `${taskId}/wiki` },
    { label: 'Чек-лист', value: `${taskId}/task_list` },
    { label: 'Файлы', value: `${taskId}/files` }
  ];

  // ==================== ФУНКЦИИ СКРОЛЛА ДЛЯ ТАБЛИЧНОГО ВИДА ====================
  const handleTableWheel = useCallback((e) => {
    // Для табличного вида обрабатываем вертикальный скролл тачпадом
    const tableContainer = tableContainerRef.current;
    if (!tableContainer || selectView !== 'Table') return;

    // Для вертикального скролла в таблице
    const isVerticalScroll = Math.abs(e.deltaY) > Math.abs(e.deltaX);

    if (isVerticalScroll) {
      // Позволяем вертикальному скроллу работать
      return;
    }

    // Для горизонтального скролла в таблице (если он есть)
    const isShiftPressed = e.shiftKey;
    const hasHorizontalScroll = Math.abs(e.deltaX) > Math.abs(e.deltaY);

    if ((isShiftPressed || hasHorizontalScroll) && tableContainer) {
      e.preventDefault();
      tableContainer.scrollLeft += e.deltaX || e.deltaY;
    }
  }, [selectView]);

  const syncScroll = useCallback(() => {
    if (refContainer.current && refScrollbar.current) {
      refScrollbar.current.scrollLeft = refContainer.current.scrollLeft;
    }
  }, []);

  const handleWheel = useCallback((e) => {
    // Если нажат Shift или это горизонтальный скролл (deltaX != 0)
    const isShiftPressed = e.shiftKey;
    const hasHorizontalScroll = Math.abs(e.deltaX) > Math.abs(e.deltaY);

    if ((isShiftPressed || hasHorizontalScroll) && refContainer.current) {
      e.preventDefault();

      const scrollDelta = e.deltaX !== 0 ? e.deltaX : e.deltaY;

      refContainer.current.scrollLeft += scrollDelta;

      // Синхронизируем скроллбар
      if (refScrollbar.current) {
        refScrollbar.current.scrollLeft = refContainer.current.scrollLeft;
      }
    }
  }, []);

  useEffect(() => {
    if (taskId) {
      if (activeTab?.includes('wiki')) {
        setPageValue(`${taskId}/wiki`)
      } else if (activeTab?.includes('task_list')) {
        setPageValue(`${taskId}/task_list`)
      } else if (activeTab?.includes('files')) {
        setPageValue(`${taskId}/files`)
      } else {
        setPageValue(`${taskId}`)
      }
    }
  }, [taskId]);


  // Получение токена для wiki
  const fetchProductIds = (id) => {
    const url = ` https://portals.ecomru.ru/api/v2/article/wiki_token?wiki_id=${id}`
    fetch(url, { method: 'GET', headers })
      .then(handleTableResponse)
      .then(json => {
        if (json) {
          setTokenWiki(json)
        }
      })
      .catch(handleRequestError)
  }

  // Получение wiki-id по проекту
  const fetchGetWikiId = (project_id) => {
    if (!project_id) return
    let url = ` https://portals.ecomru.ru/api/v3/tasks/${project_id}/wiki`

    fetch(url, { method: 'get', headers })
      .then(handleTableResponse)
      .then(json => {
        if (json?.value) {
          fetchProductIds(json?.value)
          setWikiId(json?.value)
        }
      })
      .catch(handleRequestError)
  }

  useEffect(() => {
    if (taskId != -1) {
      fetchGetWikiId(taskId)
    }
  }, [taskId]);

  useEffect(() => {
    if (countCol == columns.length) {
      setLoadTotal(false)
    }
  }, [countCol])


  const openTask = (e, eventId, project, taskId) => {
    sessionStorage.setItem('eventId', eventId);
    sessionStorage.setItem('taskProjectId', project ? project : taskId);
    setTaskId(project ? project : taskId);
    const urlParams = new URLSearchParams(window.location.search);
    if (!path.match(eventId)) {
      navigate(
        `/tasks/task-list/${taskId}/${eventId}${urlParams.toString() ? `?${urlParams.toString()}` : ''
        }`
      );
    }
    const el = e?.target;
    if (el && el?.closest('.btn-and-options-box')) {
      return;
    } else {
      fetchInfoTask(eventId);
    }
  };

  const dragStartHandler = (e, card) => {
    setActualElement(card);
  };

  const dragOverHandler = (e) => {
    e.preventDefault();
  };

  // Изменение статуса задачи(task_type)
  const fetchSetTaskType = (event_id, selected) => {
    let url = `${RavshanHttps}/api/v3/tasks/set_task_type`;

    const body_curr = JSON.stringify({
      event_id: event_id,
      task_type: selected,
    });

    fetch(url, { body: body_curr, method: 'POST', headers })
      .then(handleTableResponse)
      .then(json => { })
      .catch(handleRequestError)
  }

  // получение total
  const fetchGetTotal = (filter) => {

    setLoadTotalCount(true)

    let url = `${RavshanHttps}/api/v3/tasks/get_total_events`;

    const executor = selectedExecutor?.length > 0 ? { executor: selectedExecutor } : {};
    const author = selectedAuthor?.length > 0 ? { author: selectedAuthor } : {};
    const co_executor = selectedCoExecutor?.length > 0 ? { co_executor: selectedCoExecutor } : {};
    const taskType = selectedStatus?.length > 0
      ? { task_type: selectedStatus?.map(({ value }) => value) }
      : {};
    const task_board_id = currentBord?.id ? { task_board_id: currentBord?.id } : {}

    const body_curr = JSON.stringify({
      ...executor,
      ...co_executor,
      ...author,
      ...taskType,
      project_id: +taskId,
      search: searchValue,
      unviewed: isRead,
      on_trash: isDelete,
      ...task_board_id
    });

    fetch(url, { body: body_curr, method: 'POST', headers })
      .then(handleTableResponse)
      .then((json) => {
        const { events, projects } = json
        if (events) setTotalEvent(events)
        if (projects) setTotalProject(projects)
        setLoadTotalCount(false)
      })
      .catch(handleRequestError);
  };

  useEffect(() => {
    fetchGetTotal()
  }, [
    selectedExecutor,
    selectedCoExecutor,
    selectedStatus,
    selectedStatus,
    taskId,
    searchValue,
    isRead,
    isDelete,
    currentBord?.id
  ]);

  const dropCardHandler = (e, status) => {
    e.preventDefault();
    if (!actual) return;
    if (+taskId === -1) return;
    setPrevTasks(tasks);
    const tasksWithNewStatus = tasks.map((el) =>
      el?.event_id === actual?.event_id
        ? { ...actual, taskType: { id: status.typeId, name: status.typeName } }
        : el
    );
    setTasks(tasksWithNewStatus);
    fetchSetTaskType(actual?.event_id, status?.typeId);
    // fetchUpdateTask(actual, status)
    setActualElement(false);
  };

  const dragStartColumn = (e, column) => {
    if (!e.target.getAttribute('column')) return;
    setDraggableColumn(column);
    setColumnDragStarted(true);
  };

  const dropColumnHandler = (e, dropPlace) => {
    e.preventDefault();
    e.target.classList.remove('hover');

    if (!draggableColumn) return;
    const currentPlace = draggableColumn.place;
    if (currentPlace < dropPlace) {
      if (currentPlace === dropPlace - 1) return;
      updateTaskListPlace(dropPlace - 1);
    } else {
      if (currentPlace === dropPlace) return;
      updateTaskListPlace(dropPlace);
    }
    setDraggableColumn(null);
    setColumnDragStarted(false);
  };

  const customDragScrollHandler = (event) => {
    const container = containerRef.current;
    const scrollZoneWidth = 100;

    const cursorX = event.clientX - container?.getBoundingClientRect().left;

    if (cursorX < scrollZoneWidth) {
      container.scrollLeft -= 2;
      if (refScrollbar.current) {
        refScrollbar.current.scrollLeft = container.scrollLeft;
      }
    } else if (cursorX > container?.offsetWidth - scrollZoneWidth) {
      container.scrollLeft += 2;
      if (refScrollbar.current) {
        refScrollbar.current.scrollLeft = container.scrollLeft;
      }
    }
  };

  const handleSearch = (value) => {
    setColumnsAreUpdating(true);
    setSearchValue(value);
  };

  const checkAttendee = (id) => {
    const executor = selectedExecutor?.indexOf(id) > -1;
    const coexecutor = selectedCoExecutor?.indexOf(id) > -1;
    const author = selectedAuthor?.indexOf(id) > -1;

    return +executor + coexecutor + author;
  };

  const arr_projectAttendees = projectAttendees?.map(
    ({ id, name, login, color }, ind) => {
      return (
        <div
          className="selected-members"
          key={id}
          style={{
            cursor: 'pointer',
            border:
              selectedExecutor?.indexOf(id) !== -1
                ? '1px solid #51CA64'
                : '1px solid white',
            borderRadius: '50%',
            marginLeft: ind != 0 ? '-8px' : '',
            position: 'relative',
            zIndex: selectedExecutor?.indexOf(id) !== -1 ? 2 : 1,
          }}
          onClick={(e) => {
            setSelectedExecutor((prev) => {
              if (prev?.indexOf(id) === -1) {
                return [...prev, id];
              } else {
                return prev?.filter((el) => el !== id);
              }
            });
            setColumnsAreUpdating(true);
            setUpdateCol(true);
          }}
        >
          <ExecutorPlaceholder
            bkg={
              selectedExecutor?.length > 0 &&
                selectedExecutor?.indexOf(id) === -1
                ? '#DDE0DD'
                : ''
            }
            name={name}
            color={color}
            email={login}
          />
        </div>
      );
    }
  );

  // Проверка доступа к проекту
  const fetchAccessProject = () => {
    if (taskId == -1) {
      setIsAccessProject(true)
    } else {
      let url = ` https://portals.ecomru.ru/api/v3/tasks/check_project_permission/${taskId}`

      fetch(url, { headers })
        .then(handleTableResponse)
        .then((json) => {
          setIsAccessProject(json)
          if (json === false) {
            addErrorPush(`У вас нет доступа к проекту ID-${taskId}`)
            navigate('/tasks/project-for-tasks')
          }
        })
        .catch(handleRequestError)
    }
  };

  useEffect(() => {
    if (taskId) {
      fetchAccessProject()
    }
  }, [taskId]);

  // Проверка доступа к задаче
  const fetchAccess = (id) => {
    let url = ` https://portals.ecomru.ru/api/v3/tasks/check_event_permission/${id}`
    setIsLoadInfoTask(true);

    fetch(url, { headers })
      .then(handleTableResponse)
      .then((json) => {
        setIsAccess(json)
        if (json === false) {
          addErrorPush(`У вас нет доступа к задаче ID-${id}`)
          navigate('/tasks/project-for-tasks')
        }
      })
      .catch(handleRequestError)
  };


  useEffect(() => {
    const paths = path?.split('/');
    const [project, task] = paths;
    if (task) {
      fetchAccess(task)
    }
  }, [path]);

  const fetchInfoTask = (id) => {
    let url = `${RavshanHttps}/api/tasks/get_event`;

    setIsLoadInfoTask(true);

    const getHeaders = {
      ...headers,
      'event-id': +id,
      active: true,
    };

    fetch(url, { headers: getHeaders })
      .then(handleTableResponse)
      .then((json) => {
        setInfoTask(fromSnakeCase(json));
        if (pageValue !== `${taskId}/wiki` &&
          pageValue !== `${taskId}/task_list` &&
          pageValue !== `${taskId}/files`) {
          setIsModal(true)
        }
      })
      .catch(handleRequestError)
      .finally(() => setIsLoadInfoTask(false));
  };

  // Список статусов в по сотрудникам
  const fetchTaskTypes = (id) => {
    let url = `${RavshanHttps}/api/v3/tasks/get_task_type_list`;

    fetch(url, { headers: headers })
      .then(handleTableResponse)
      .then((json) => {
        setStatusOptions(
          json?.map((el) => ({ label: el, value: el }))
        );
      })
      .catch(handleRequestError)
      .finally(() => setIsLoadInfoTask(false));
  };

  useEffect(() => {
    if (taskId == -1 && isAccessProject) {
      fetchTaskTypes()
    }
  }, [taskId, isAccessProject]);

  const fetchProjects = (taskId, abortController = new AbortController()) => {
    if (!taskId) return;

    setLoad(true);

    let url = `${RavshanHttps}/api/v2/tasks/get_event_by_project_new`;

    const executor =
      selectedExecutor?.length > 0 ? { executor: selectedExecutor } : {};
    const author = selectedAuthor?.length > 0 ? { author: selectedAuthor } : {};
    const co_executor =
      selectedCoExecutor?.length > 0 ? { co_executor: selectedCoExecutor } : {};
    const taskType =
      selectedStatus?.length > 0
        ? { task_type: selectedStatus?.map(({ value }) => value) }
        : {};

    const body = JSON.stringify({
      project_id: +taskId,
      ...executor,
      ...co_executor,
      ...author,
      ...taskType,
      unviewed: isRead,
      order_param: currentSort?.value ? currentSort?.value : 'date',
      order_param_direction: sort1 ? sort1 : 'DESC',
      search: searchValue,
      on_trash: isDelete,
    });

    fetch(url, { body, method: 'POST', headers, signal: abortController.signal })
      .then(handleTableResponse)
      .then((json) => {
        const { project_name, author, attendee, task_type_list } = json;
        setProjectName(project_name ? project_name : 'По сотрудникам');
        setAuthor(author);
        // setStatusOptions(
        //   task_type_list?.map((el) => ({ label: el, value: el }))
        // );
        setProjectAttendees(
          attendee.sort((a, b) => checkAttendee(b.id) - checkAttendee(a.id))
        );
      })
      .catch(handleRequestError)
      .finally(() => setLoad(false));
  };



  const fetchGetAttendees = (abortController = new AbortController()) => {
    if (!taskId) return;

    let url = `${RavshanHttps}/api/v3/tasks/get_attendees/${taskId}`;

    fetch(url, { method: 'GET', headers, signal: abortController.signal })
      .then(handleTableResponse)
      .then((json) => {
        // const { project_name, author, events, attendee, task_type_list } = json
        // setProjectName(project_name ? project_name : 'По сотрудникам')
        // setAuthor(author)
        // setTasks(events?.map(e => fromSnakeCase(e)).filter(e => e.eventType === TASK_EVENT_TYPE))
        json?.forEach((el) => {
          const { login, color, name } = el;
          if (login === email) {
            localStorage.setItem('currentUserColor', color);
            localStorage.setItem('currentUserName', name);
          }
        });
        // setStatusOptions(task_type_list?.map(el => ({ label: el, value: el })))
        setProjectAttendees(
          json.sort((a, b) => checkAttendee(b.id) - checkAttendee(a.id))
        );
      })
      .catch(handleRequestError);
  };

  useEffect(() => {
    fetchGetAttendees();
  }, [taskId]);

  const fetchProjectsAttendee = (taskId) => {
    if (!taskId) return;

    let url = `${RavshanHttps}/api/tasks/project_client_team`;

    const getHeaders = {
      ...headers,
      'project-id': +taskId,
    };

    fetch(url, { headers: getHeaders })
      .then(handleTableResponse)
      .then((json) => setProjectAttendees(json.sort((a, b) => checkAttendee(b.id) - checkAttendee(a.id))))
      .catch(handleRequestError);
  };

  const fetchAllColumns = (
    delayMs,
    taskId,
    abortController = new AbortController()
  ) => {
    if (!taskId) return;
    if (!currentBord?.id && taskId != -1) return

    setColumnsAreUpdating(true);
    setCountCol(0)
    setLoadTotal(true)
    const url = `${RavshanHttps}/api/v3/tasks/get_task_type`;
    const executor =
      selectedExecutor?.length > 0 ? { executor: selectedExecutor } : {};
    const author = selectedAuthor?.length > 0 ? { author: selectedAuthor } : {};
    const coexecutor =
      selectedCoExecutor?.length > 0 ? { co_executor: selectedCoExecutor } : {};
    const taskTypeValue = selectedStatus?.map(({ value }) => value);
    const taskType = taskTypeValue ? { task_type: taskTypeValue } : {};

    const task_board_id = currentBord?.id ? { task_board_id: currentBord?.id } : {}

    const body = JSON.stringify({
      project_id: +taskId,
      ...executor,
      ...author,
      ...coexecutor,
      ...taskType,
      unviewed: isRead,
      search: searchValue,
      on_trash: isDelete,
      ...task_board_id
    });

    const fetchCallback = () =>
      fetch(url, { method: 'POST', headers, body, signal: abortController.signal })
        .then(handleTableResponse)
        .then((json) => {
          if (!Array.isArray(json)) return;
          setColumns(
            json.sort((a, b) => a.place - b.place).map((c) => fromSnakeCase(c))
          );
          setGeneralTotal(0)
        })
        .finally(() => {
          if (abortController.signal.aborted) return;
          setColumnsAreUpdating(false);
        });

    if (delayMs) setTimeout(fetchCallback, delayMs);
    else fetchCallback();
  };


  const fetchDeleteTask = (id, on_trash) => {
    let url;
    url = `${RavshanHttps}/api/tasks/delete_event`;

    const body = JSON.stringify({
      event_id: id,
      on_trash: on_trash,
    });

    fetch(url, { body, method: 'DELETE', headers })
      .then(async (res) => {
        const data = await res.json();
        if (!res.ok) {
          const errorMessage = data.detail || res.statusText;
          addErrorPush(`Ошибка: ${errorMessage}`);
          throw new Error(`${res.status} ${errorMessage}`);
        } else {
          addSuccessPush(`Задача ID-${id} удалена`)
        }
        return data;
      })
      .then(() => { })
      .catch(handleRequestError)
      .finally(() => setIsModal(false))
  }

  const addNewTaskList = (name) => {
    const url = `${RavshanHttps}/api/tasks/post_task_type`;
    const body = JSON.stringify({
      name,
      place: columns.length + 1,
      task_id: +taskId,
      task_board_id: currentBord?.id
    });
    fetch(url, { body, method: 'POST', headers })
      .then(res => {
        if (res.status === 409) {
          addErrorPush('Лимиты по тарифу исчерпаны')
          navigate('/tasks/project-for-tasks')
        }
        if (!res?.ok) {
          throw new Error('bad response')
        }
        if (res?.ok) {
          fetchAllColumns(500, +taskId);
        }
        return res.json()
      })
  };

  const updateTaskListPlace = (newPlace) => {
    const url = `${RavshanHttps}/api/tasks/change_task_type_position`;
    const body = JSON.stringify({
      place: newPlace,
      task_id: +taskId,
      type_id: draggableColumn.typeId,
    });
    fetch(url, { body, method: 'POST', headers }).then((response) => {
      if (response.ok) {
        fetchAllColumns(500, +taskId);
        fetchProjects(+taskId);
        setUpdateCol(true);
      } else {
        throw new Error('bad update task list place response');
      }
    });
  };

  const changeTaskListName = (column, newName) => {
    setColumnNameIsUpdating(true);
    const url = `${RavshanHttps}/api/tasks/put_task_type`;
    const body = JSON.stringify({
      place: column.place,
      name: newName,
      task_id: +taskId,
      type_id: column.typeId,
    });
    fetch(url, { body, method: 'PUT', headers })
      .then((response) => {
        if (response.ok) {
          fetchAllColumns(false, +taskId);
          fetchProjects(+taskId);
        } else {
          throw new Error('bad update task list response');
        }
      })
      .finally(() => setColumnNameIsUpdating(false));
  };

  const openModal = (column) => {
    setIsNew(true);
    setSelectedColumn(column);
    setIsModal(true);
  };

  const addNewMember = (client_id) => {
    const project_id = +taskId;
    const url = ` https://portals.ecomru.ru/api/v3/tasks/add_attendee`;

    const body = JSON.stringify({
      client_id,
      project_id,
    });

    fetch(url, { body, method: 'POST', headers })
      .then(handleTableResponse)
      .then((json) => fetchProjectsAttendee(project_id))
      .catch(handleRequestError);
  };

  const deleteNewMember = (client_id) => {
    const project_id = +taskId;
    const url = ` https://portals.ecomru.ru/api/v3/tasks/remove_attendee`;

    const body = JSON.stringify({
      client_id,
      project_id,
    });

    fetch(url, { body, method: 'DELETE', headers })
      .then(handleTableResponse)
      .then((json) => fetchProjectsAttendee(project_id))
      .catch(handleRequestError);
  };

  const fetchProjectPreview = (
    taskId,
    abortController = new AbortController()
  ) => {
    let url = `${RavshanHttps}/api/tasks/get_project_preview`;

    fetch(url, { headers, signal: abortController.signal })
      .then(handleTableResponse)
      .then((json) => {
        setProjectPreview(
          [{ name: 'По сотрудникам', id: -1, author: undefined }, ...json]?.map(
            ({ id, name, author }) => ({ label: name, value: { id, author } })
          )
        );
        if (!projectName & taskId) {
          const projectName = json.filter(({ id }) => id === +taskId)[0]?.name;
          sessionStorage.setItem(
            'taskProjectName',
            projectName
              ? projectName
              : taskId === -1
                ? 'По сотрудникам'
                : 'Не найдено'
          );
        }
      })
      .catch(handleRequestError);
  };

  const fetchProjectToRedirect = (projectId) => {
    const url = `${RavshanHttps}/api/tasks/get_project`;

    const body = JSON.stringify({
      executor: selectedExecutor,
      search: '',
    });

    fetch(url, { body, headers })
      .then(handleTableResponse)
      .then((projects) => {
        const project = projects?.filter((el) => el?.task_id === +projectId)[0];
        if (project) {
          const { name, task_id } = project;
          sessionStorage.setItem(
            'taskProjectName',
            name ? name : taskId === -1 ? 'По сотрудникам' : 'Не найдено'
          );
          navigate(`/tasks/task-list/${task_id}`);
        }
      })
      .catch(handleRequestError);
  };

  const deleteTaskList = () => {
    const url = `${RavshanHttps}/api/tasks/delete_task_type`;
    const body = JSON.stringify({
      task_id: +taskId,
      type_id: removableTaskList.typeId,
    });
    fetch(url, { body, method: 'DELETE', headers }).then((response) => {
      if (response.ok) {
        fetchAllColumns(false, +taskId);
        fetchProjectPreview();
        fetchProjects(+taskId);
      } else {
        throw new Error('bad delete task list response');
      }
    });
  };

  const fetchTableData = (params, abortController = new AbortController()) => {
    let _sort;
    let filtersParam;

    if (params) {
      [_sort, filtersParam] = params;
    }
    setLoading(true);
    setTableData([]);

    let url_by_employee = 'https://portals.ecomru.ru/api/v3/tasks/table_view_attendee_project'
    let url = `https://portals.ecomru.ru/api/v3/tasks/table_view/${currentBord?.id}`

    const body = JSON.stringify({
      limit: paginatorRef?.current?.limit || 10,
      page: paginatorRef?.current?.page || 1,
      order_param: _sort?.[0] || sort?.[0],
      search: searchValue,
      task_type: selectedStatus?.map(({ value }) => value),
      unviewed: isRead,
      on_trash: isDelete,
      executor: selectedExecutor?.length > 0 ? selectedExecutor : [],
      author: selectedAuthor?.length > 0 ? selectedAuthor : [],
      co_executor: selectedCoExecutor?.length > 0 ? selectedCoExecutor : [],
      order_param_direction: _sort?.[1] || sort?.[1],
      filters: Array.isArray(filtersParam) ? filtersParam : filters,
    });

    fetch(taskId == -1 ? url_by_employee : url, { body, method: 'POST', headers, signal: abortController.signal })
      .then(handleTableResponse)
      .then((json) => {
        json?.data?.map((el) => {
          if (el[3] && typeof el[3] === 'string') {
            el[3] = parse(el[3]);
          }
          if (!el[1]) {
            el[1] = 'Нет названия';
          }
          return el;
        });
        setTable(json);
      })
      .catch(handleRequestError)
      .finally(() => {
        if (abortController.signal.aborted) return
        setLoading(false)
      })
  };

  // Получение id файловой системы
  const fetchGetFileId = () => {
    if (!taskId) return
    let url = ` https://portals.ecomru.ru/api/v3/tasks/${taskId}/file_system_id`

    fetch(url, { method: 'GET', headers })
      .then(handleTableResponse)
      .then((json) => {
        if (json) {
          setFileId(json)
        }
      })
      .catch(handleRequestError);
  }

  useEffect(() => {
    if (taskId) {
      fetchGetFileId()
    }
  }, [taskId]);

  // Таблица
  useEffect(() => {
    if (selectView == 'Table' && !isModal) {
      const abortController = new AbortController()
      setTimeout(() => fetchTableData([], abortController), 500)
      return () => abortController.abort()
    }
  }, [
    selectView,
    searchValue,
    selectedExecutor,
    selectedAuthor,
    selectedCoExecutor,
    currentBord?.id,
    isModalDeleteCol,
    isModal,
    isDelete,
    isRead
  ]);

  useEffect(() => {
    const paths = path?.split('/');
    if (paths) {
      const [project, task] = paths;
      if (project) {
        sessionStorage.setItem('taskProjectId', project);
        setTaskId(project);
        setCurrPrjoect(project);
      }
      if (!projectName) {
        fetchProjectPreview(+project);
      }
      if (task) {
        sessionStorage.setItem('eventId', task);
        if (!(activeTab.includes('wiki') ||
          activeTab.includes(`task_list`) ||
          activeTab.includes(`files`))) {
          if (isAccess) {
            openTask(null, task, +project, taskId);
          }
        }
        if (project) {
          fetchProjects(+project);
          fetchAllColumns(false, +project);
        }
      }
      return;
    }
    if (!taskId) {
      navigate('/tasks/project-for-tasks');
      return;
    } else {
      if (eventId) {
        navigate(`/tasks/task-list/${taskId}/${eventId}`);
      }
    }
  }, [selectedSpace, isAccess]);

  useEffect(() => {
    if (taskId && isAccessProject) {
      const abortController = new AbortController();
      fetchProjects(taskId, abortController);
    }
  }, [taskId, isAccessProject]);

  useEffect(() => {
    const abortController = new AbortController();
    if (!isModal || columns?.length < 1) {
      //   setLoad(true)
      setTimeout(() => {
        fetchAllColumns(false, taskId, abortController);
        fetchProjectPreview(taskId, abortController);
      }, FETCH_DELAY_MS);

      if (updateCol) {
        setUpdateCol(false)
      }
    }
    return () => abortController.abort()
  }, [
    selectedSpace,
    showModalAddMember,
    searchValue,
    updateCol,
    taskId,
    sort1,
    currentSort,
    isRead,
    isDelete,
    searchValue,
    currentBord
  ])

  useEffect(() => {
    if (!isModal) {

    }
  }, [isModal]);

  useEffect(() => {
    if (iniitalQuery) {
      const dataObj = getFiltersByUrlQuery(searchParams);
      addFiltersByDataObj({
        dataObj,
        setSelectedAuthor,
        setSelectedExecutor,
        setSelectedCoExecutor,
        setCurrentSort,
        setSelectedStatus,
        setSearchValue,
        setSort1,
        setCurrentBord
      });
      setInitialQuery(false);
    }
  }, [searchParams]);

  //Запись
  useEffect(() => {
    if (iniitalQuery) return;
    const dataObj = getDataObjByFilters({
      selectedAuthor,
      selectedCoExecutor,
      selectedExecutor,
      selectedStatus,
      currentSort,
      searchValue,
      sort1,
      currentBord
    });
    addFiltersToUrlQuery(dataObj, setSearchParams);
  }, [
    selectedAuthor,
    selectedCoExecutor,
    selectedExecutor,
    selectedStatus,
    currentSort,
    searchValue,
    sort1,
    currentBord
  ]);



  useEffect(() => {
    const id = selectedProjectPreview?.value?.id;
    if (id) {
      fetchProjectToRedirect(id);
    }
  }, [selectedProjectPreview, selectedSpace]);

  const handleScroll = () => {
    const container = refContainer.current;
    const headerr = refHeader.current;
    const header = document.querySelector('.col-task__white');
    const top = container.getBoundingClientRect().top;
    const bottom = container.getBoundingClientRect().top;

    let height;
    if (header) {
      height = header.getBoundingClientRect().height;
    }

    if (top < 0) {
      setPositionElement(-top);
    } else {
      setPositionElement(0);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const observer = new ResizeObserver((entries) => {
    const { width } = entries[0].contentRect;
    setWidthTaskList(width);
  });

  useEffect(() => {
    if (refContainer?.current) {
      observer.observe(refContainer?.current);
    }
  }, [refContainer, observer]);

  // Синхронизируем скролл
  const positionScroll = () => {
    if (refContainer?.current && refScrollbar?.current) {
      refContainer.current.scrollLeft = refScrollbar.current.scrollLeft;
    }
  };

  const scrollBottom = () => {
    positionScroll();
    const left = refContainer?.current?.getBoundingClientRect().left;
    // const width = refContainer?.current?.scrollWidth;
    const width = (columns?.length * 240)
    const scrollWidth = refTaskBox?.current?.scrollWidth;

    // Ширина таблицы
    const widthTaskList = refContainer?.current?.getBoundingClientRect().width;
    setWidthTaskList(widthTaskList);
    setLeftPosition(left); //left
    // setWidtContainer(width); //right
    //  setScrollWidth(scrollWidth) //width

    // Видимость скроллбара
    const heightDocument = document.documentElement.clientHeight;
    setBottom(refContainer?.current?.getBoundingClientRect().bottom);
    if (heightDocument) {
      const pointBottom =
        refContainer?.current?.getBoundingClientRect().bottom >
        document.documentElement.clientHeight;
      const pointTop = refContainer?.top > 0;
      setIsFixed(pointBottom || pointTop ? true : false);
    }

    //верхняя точка скроллбара
    if (heightDocument) {
      const pointTop =
        refContainer?.current?.getBoundingClientRect().top >
        document.documentElement.clientHeight;
      setIsVisible(pointTop ? false : true);
    }
  };

  // // скролл таблицы shift + wheel
  const scrollWheel = (e) => {
    const isShift = e?.shiftKey;
    if (refContainer?.current && refScrollbar?.current && isShift) {
      refScrollbar.current.scrollLeft = refContainer.current.scrollLeft;
    }
  };

  // // Скролл кнопками
  const scrollKey = (e) => {

    //  refContainer?.current?.scrollLeft = refScrollbar?.current.scrollLeft

    if (!isModal & !isBlockKey) {
      const left = 37;
      const right = 39;

      if (e?.keyCode === left || e?.keyCode === right) {
        refContainer?.current?.focus();
      }
    }

    if (refContainer?.current && refScrollbar?.current && !isBlockKey) {
      refScrollbar.current.scrollLeft = refContainer.current.scrollLeft;
    }
  };

  // Настройка обработчиков скролла для табличного вида
  useEffect(() => {
    if (selectView === 'Table' && tableContainerRef.current) {
      const tableContainer = tableContainerRef.current;

      const tableWheelHandler = (e) => {
        handleTableWheel(e);
      };

      tableContainer.addEventListener('wheel', tableWheelHandler, { passive: false });

      return () => {
        tableContainer.removeEventListener('wheel', tableWheelHandler);
      };
    }
  }, [selectView, handleTableWheel]);

  // Настройка обработчиков скролла для обычного вида
  useEffect(() => {
    const container = refContainer.current;
    const scrollbar = refScrollbar.current;

    if (!container || selectView === 'Table') return;

    // Обработчик wheel для тачпада
    const wheelHandler = (e) => {
      handleWheel(e);
    };

    // Обработчик скролла для синхронизации
    const scrollHandler = () => {
      syncScroll();
    };

    // Добавляем слушатели
    container.addEventListener('wheel', wheelHandler, { passive: false });
    container.addEventListener('scroll', scrollHandler);

    if (scrollbar) {
      scrollbar.addEventListener('scroll', () => {
        if (container) {
          container.scrollLeft = scrollbar.scrollLeft;
        }
      });
    }

    return () => {
      // Убираем слушатели при размонтировании
      container.removeEventListener('wheel', wheelHandler);
      container.removeEventListener('scroll', scrollHandler);

      if (scrollbar) {
        scrollbar.removeEventListener('scroll', () => { });
      }
    };
  }, [handleWheel, syncScroll, selectView]);

  useEffect(() => {
    const widthTaskList = (columns?.length * 256) + (isOpen ? 210 : 48);
    setWidtContainer(widthTaskList);
  }, [columns, isOpen]);

  useEffect(() => {
    window.addEventListener('scroll', scrollBottom);
    window.addEventListener('resize', scrollBottom);
    refContainer?.current?.addEventListener('wheel', scrollWheel);

    return () => {
      window.removeEventListener('scroll', scrollBottom);
      window.removeEventListener('resize', scrollBottom);
      refContainer?.current?.removeEventListener('wheel', scrollWheel);
    };
  }, [isModal]);

  useEffect(() => {
    // refContainer?.current?.focus();
    window?.addEventListener('keydown', scrollKey);

    return () => {
      window?.removeEventListener('keydown', scrollKey);
    };
  }, [
    refContainer?.current,
    columns?.length,
    isModal,
    showModalAddMember,
    showModalNewTaskList,
    isModalListExecutor,
    isModalDeleteCol,
    isChatModal,
    isBlockKey
  ]);

  useEffect(() => {
    positionScroll();
    scrollBottom();
  }, [refTaskBox?.current]);

  useEffect(() => {
    positionScroll();
    scrollBottom();
  }, [tasks]);


  useEffect(() => {
    const params = new URL(document.location).searchParams;
    let query = params.get('filter');
    setQuery(query);
    if (query == 'my_project') {
      setSelectedAuthor([Number(client_id)]);
    }
  }, []);


  // Смена проекта без перезагрузки страницы:
  // меняем URL через navigate, а обёртка TaskList перемонтирует компонент по key
  useEffect(() => {
    if ((currPrjoect != taskId) && taskId && currPrjoect?.id != null) {
      const urlParams = new URLSearchParams(window.location.search);
      navigate(
        `/tasks/task-list/${currPrjoect.id}${urlParams.toString() ? `?${urlParams.toString()}` : ''
        }`
      );
    }
  }, [currPrjoect]);

  // Получение id 
  const fetchGetId = (id) => {
    let url = `https://portals.ecomru.ru/api/v3/tasks/task_list_id/${id}`

    fetch(url, { method: 'GET', headers })
      .then(handleTableResponse)
      .then((json) => setIdTable(json))
      .catch(handleRequestError);
  };

  useEffect(() => {
    fetchGetId(taskId)
  }, [taskId]);

  const onActionTable = (e) => {
    const paths = path?.split('/');
    if (paths) {
      const [project, task] = paths;
      openTask(null, e?.[`id задачи`], +project, taskId);
    }
  }

  const deboudnceSearchTask = useDebounce(handleSearch, 1000)

  return (
    <>
      {/* СПИСОК СОТРУДНИКОВ */}
      {showModalAddMember && <ModalAddExecutor
        task
        projectAttendees={projectAttendees?.map(el => el?.id)}
        addNewMember={name => addNewMember(name)}
        deleteMember={deleteNewMember}
        close={() => setShowModalAddMember(false)}
        projectId={taskId} />}

      {showModalNewTaskList && <ModalNewTaskList
        add={name => addNewTaskList(name)}
        close={() => setShowModalNewTaskList(false)}
      />}

      {isModalListExecutor && <ModalListExecutor
        setColumnsAreUpdating={setColumnsAreUpdating}
        executors={projectAttendees}
        setIsModal={setIsModalListExecutor}
        selectedExecutor={selectedExecutor}
        selectedCoExecutor={selectedCoExecutor}
        selectedAuthor={selectedAuthor}
        setSelectedAuthor={setSelectedAuthor}
        checkAttendee={checkAttendee}
        setSelectedExecutor={setSelectedExecutor}
        setSelectedCoExecutor={setSelectedCoExecutor}
        updateData={e => {
          fetchAllColumns(false, +taskId)
          fetchProjects(+taskId)
          fetchProjectPreview()
        }}
      />}

      {/* Удаление колонки */}

      {isModalDeleteCol &&
        <ModalWarning
          headerText='Подтвердите удаление'
          messageText={`Удалить колонку “${removableTaskList.typeName}”?`}
          approveButtonText='Удалить'
          cancelButtonText='Отмена'
          colorBtn='red'
          onApproveClick={() => {
            deleteTaskList()
            setIsModalDeleteCol(false)
          }}
          onCancelClick={() => setIsModalDeleteCol(false)}
        />
      }

      {isModalStatus &&
        <ModalTaskStatus
          columns={columns}
          currentColumn={currentColumn}
          setIsModal={setIsModalStatus}
        />
      }

      {isModal && <ModalAddTask
        isNew={isNew}
        event_id={eventId}
        setIsNew={setIsNew}
        setIsModal={setIsModal}
        setIsModalExit={setIsModalExit}
        infoTask={infoTask}
        isLoadInfoTask={isLoadInfoTask}
        attendees={projectAttendees}
        taskId={taskId}
        setInfoTask={setInfoTask}
        setTasks={setTasks}
        selectedColumn={selectedColumn}
        allColumns={projectPreview}
        query={query}
        fetchDeleteTask={fetchDeleteTask}
        searchParams={searchParams}
        setUpdateId={setUpdateId}
        setActualId={setActualId}
        // Обновление колонок
        isUpdateDataColumn={isUpdateDataColumn}
        setIsUpdateColumn={setIsUpdateColumn}
        task
      />}

      {
        isChatModal &&
        <ChatModal
          setIsModal={setIsChatModal}
        />
      }

      <div className='task-list'
        style={{ maxHeight: selectView === 'Table' ? '100%' : '' }}
      >
        {taskId != -1 && <Tabs
          tabs={btn_tab}
          pageValue={pageValue}
          //   spanTab
          setPageValue={(e) => {
            setPageValue(e);
          }}
        />}

        <Routes>
          <Route
            path="*"
            element={
              <>
                <div className="task-list__top-info">
                  <div className="task-list__breadcrumbs">
                    <p
                      onClick={(e) => {
                        sessionStorage.removeItem('taskProjectId');
                        setTaskId(null);
                        sessionStorage.removeItem('taskProjectName');
                        setSelectedProjectAbove(null);
                        navigate('../project-for-tasks');
                      }}
                      className="task-list__breadcrumbs-item"
                    >
                      Проекты
                    </p>
                    <p
                      className="task-list__breadcrumbs-item"
                      style={{ position: 'relative', zIndex: 7 }}
                    >
                      <DropDownSelector
                        state={[{ label: projectName, value: taskId }]}
                        options_prop={projectPreview}
                        setState={(project) => {
                          if (project?.label) {
                            const { label, value } = project;
                            sessionStorage.setItem('taskProjectName', label);
                            setCurrPrjoect(value);
                            setSelectedStatus([]);
                            setSearchValue('')
                          }
                        }}
                        onBlur={(e) => refContainer?.current?.focus()}
                      />
                    </p>

                    <ButtonBasic
                      whiteGreen
                      text='Обновить'
                      width='auto'
                      onClick={() => setIsUpdateColumn(!isUpdateDataColumn)}
                    />
                  </div>

                  <div className="task-list__sum-tasks">
                    {+taskId === -1 && (
                      <p className="task-list__sum-text">
                        Всего проектов: <span className='task-list__sum-text_span'>
                          {loadTotalCount ? <MoonLoader size={10} /> : (totalProject || 0)}
                          {/* {columns?.length || 0} */}
                        </span>
                      </p>
                    )}
                    <p className="task-list__sum-text">
                      Всего задач: {<span className='task-list__sum-text_span'>
                        {loadTotalCount ? <MoonLoader size={10} /> : (totalEvent || 0)}
                      </span>}
                    </p>
                  </div>

                  <ButtonTelegramm
                    id={taskId}
                    title='Подпишись на уведомления'
                  />
                </div>

                <div className="toolbar-top">
                  <div className="left-box">
                    <div className="members-box">
                      <Tooltip
                        child={
                          <ButtonWithIcon
                            grey
                            round
                            icon={add_user}
                            style={{
                              marginRight: '8px'
                            }}
                            onClick={(e) => {
                              setShowModalAddMember(true)
                            }}
                          />
                        }
                        text="Добавить участника"
                        maxWidth='150px'
                      />


                      <>
                        {isShowAllExecutor
                          ? arr_projectAttendees
                          : arr_projectAttendees?.splice(0, 6)}

                        {selectedExecutor?.length > 0 && (
                          <button
                            className="btn-close"
                            onClick={(e) => {
                              setSelectedExecutor([]);
                              setUpdateCol(true);
                            }}
                          >
                            <img src={close_icon} />
                          </button>
                        )}

                        <ButtonWithIcon
                          whiteGreen
                          round
                          icon={<span style={{ fontSize: '10px', fontWeight: 600 }}>+ {projectAttendees?.length > 7 ? projectAttendees?.length - 6 : ''}</span>}
                          style={{
                            marginLeft: '8px'
                          }}
                          onClick={(e) => setIsModalListExecutor(true)}
                        />
                      </>

                    </div>
                    <>
                      {+taskId === -1 && (
                        <DropDownSelector
                          placeholder="Статус"
                          isClearable={true}
                          options_prop={statusOptions}
                          state={selectedStatus}
                          total={statusOptions?.length}
                          setState={(e) => {
                            setSelectedStatus(e);
                          }}
                          multi
                          onBlur={(e) => {
                            fetchAllColumns(false, +taskId);
                            fetchTableData([])
                            fetchProjects(+taskId);
                            fetchProjectPreview();
                            refContainer?.current?.focus();
                            setIsUpdateColumn(!isUpdateDataColumn)
                          }}
                        />
                      )}

                      {selectView == 'Tile-long' && <ButtonsSort
                        btnSort={btn_sort}
                        currentSort={currentSort}
                        setCurrentSort={setCurrentSort}
                        sort={sort1}
                        setSort={setSort1}
                      />}
                    </>

                    <Checkbox value={isRead} onChange={(checked) => {
                      setIsRead(checked)
                      refContainer?.current?.focus();
                    }}>
                      Показать непрочитанные
                    </Checkbox>

                    <Checkbox
                      value={isShowAuthor}
                      onChange={(checked) => {
                        setIsShowAuthor(!isShowAuthor)
                        refContainer?.current?.focus();
                      }}
                    >
                      Показать создателя
                    </Checkbox>

                    <Checkbox
                      value={isDelete}
                      onChange={(checked) => {
                        setIsDelete(checked)
                        refContainer?.current?.focus();
                      }}
                    >
                      В корзине
                    </Checkbox>

                    <ButtonBasic
                      green
                      text={!isVisibleCheckbox ? 'Выбрать для печати' : `Печать ${listPrint?.length}`}
                      width='auto'
                      onClick={() => {
                        if (!isVisibleCheckbox) {
                          setIsVisibleCheckbox(true)
                        } else {
                          alert(`Распечатать задачи ${listPrint}`)
                        }
                      }}
                    />
                  </div>

                  <div className="right-filter-box">
                    <InputDynamicWidth
                      placeholder="Поиск задачи"
                      position="left"
                      maxWidth="100%"
                      drop={false}
                      value={searchValue}
                      onChange={deboudnceSearchTask}
                    />

                    <ViewSwitch
                      tile={false}
                      selectView={selectView}
                      setSelectView={(e) => {
                        setSelectView(e)
                        refContainer?.current?.focus();
                      }}
                    />
                  </div>
                </div>

                <div
                  ref={refContainer}
                  className="main-task-box"
                  tabIndex={5}
                  style={{
                    outline: 'none',
                    overflowX: selectView === 'Table' ? 'visible' : (isBlockKey ? 'hidden' : 'auto'),
                    overflowY: selectView === 'Table' ? 'visible' : 'hidden',
                    maxWidth: ((selectView === 'Table') && (taskId != -1)) ? 'calc(100% - 218px)' : '100%',
                    gap: selectView == 'Table' ? '8px' : '',
                  }}
                >

                  {+taskId != -1 && <BordTask
                    taskId={taskId}
                    isOpen={isOpen}
                    setIsOpen={setIsOpen}
                    setCurrentBordTask={setCurrentBord}
                    ref={refBoard}
                    dependenciesUpdate={[updateId, actualId]}
                    setBordListLength={setBordListLength}
                    task
                  />}

                  <div
                    ref={refTable}
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      width: '100%',
                      overflowX: selectView == 'Table' ? 'visible' : '',
                      overflowY: selectView == 'Table' ? 'visible' : '',
                      gap: selectView == 'Table' ? '8px' : '',
                    }}
                  >
                    {(taskId != -1 && author?.login == email && selectView !== 'Table') &&
                      <>
                        <ButtonBasic
                          whiteBlue
                          width='240px'
                          onClick={() => setShowModalNewTaskList(true)}
                          text={'Добавить колонку'}
                          size="40px"
                          disabled={!currentBord}
                          style={{
                            minHeight: '40px',
                            margin: '0px 8px 8px 8px'
                          }}
                        />

                        {bordListLength > 0 ? null : <StepItem
                          title='Для начала работы создайте доску в панели слева'
                        />}

                        {(bordListLength > 0 && !currentBord && !columns?.length) && <StepItem
                          title='Для начала работы выберите доску в панели слева'
                        />}
                      </>
                    }

                    {selectView == 'Tile-long' && (
                      <div
                        className={`task-list__content ${columnsAreUpdating ? 'loading' : ''
                          }`}
                        dragover={columnDragStarted.toString()}
                        onDrag={(e) => customDragScrollHandler(e)}
                        ref={refTaskBox}
                      >
                        {load ? (
                          <Loader style={{ marginTop: '200px' }} />
                        ) : (
                          <>
                            {columns?.length > 0 &&
                              !load &&
                              columns
                                .sort((c1, c2) => c1.place - c2.place)
                                .map((col, ind) => (
                                  <Fragment key={col.typeId}>
                                    {
                                      <div
                                        className="task-list__hover-box"
                                        onDragOver={(e) => {
                                          if (author?.login == email) {
                                            e.preventDefault();
                                            setIsOver(ind); // Устанавливаем состояние при перетаскивании
                                          }
                                        }}
                                        onDrop={(e) => {
                                          if (draggableColumn) {
                                            if (author?.login == email) {
                                              dropColumnHandler(e, col.place);
                                              setIsOver(false);
                                            }
                                          }
                                        }}
                                        onDragEnter={(e) => {
                                          if (author?.login == email) {
                                            e.target.classList.add('hover');
                                            setIsOver(false);
                                          }
                                        }}
                                        onDragLeave={(e) => {
                                          if (author?.login == email) {
                                            e.target.classList.remove('hover');
                                            setIsOver(false); // Сбрасываем состояние при выходе
                                          }
                                        }}
                                        style={{
                                          border:
                                            isOver === ind
                                              ? '1px solid #51CA64'
                                              : 'transparent',
                                        }}
                                      >
                                        <ColumnTask
                                          typeId={col.typeId}
                                          isShowAuthor={isShowAuthor}
                                          dragStartColumn={dragStartColumn}
                                          dragOverHandler={dragOverHandler}
                                          dropCardHandler={dropCardHandler}
                                          setIsOver={setIsOver}
                                          projectName={projectName}
                                          col={col}
                                          setIsEditCol={setIsEditCol}
                                          isEditCol={isEditCol}
                                          setIsBlockKey={setIsBlockKey}
                                          changeTaskListName={changeTaskListName}
                                          setCurrentColumn={setCurrentColumn}
                                          setIsModalStatus={setIsModalStatus}
                                          taskId={taskId}
                                          setRemovableTaskList={setRemovableTaskList}
                                          setIsModalDeleteCol={setIsModalDeleteCol}
                                          openModal={openModal}
                                          setSelectedColumn={setSelectedColumn}
                                          setIsModal={setIsModal}
                                          columnNameIsUpdating={columnNameIsUpdating}
                                          fetchProjectToRedirect={fetchProjectToRedirect}
                                          author={author}
                                          email={email}
                                          actual={actual}
                                          refHeader={refHeader}
                                          isOpenActiveMenu={isOpenActiveMenu}
                                          // tasksByStatus={tasksByStatus}
                                          dragStartHandler={dragStartHandler}
                                          task_permissible={task_permissible}
                                          openTask={openTask}
                                          fetchDeleteTask={fetchDeleteTask}
                                          setIsOpenActiveMenu={setIsOpenActiveMenu}
                                          selectedExecutor={selectedExecutor}
                                          selectedAuthor={selectedAuthor}
                                          selectedCoExecutor={selectedCoExecutor}
                                          selectedStatus={selectedStatus}
                                          setLoad={setLoad}
                                          headers={headers}
                                          body={{
                                            unviewed: isRead,
                                            order_param: currentSort?.value ? currentSort?.value : 'date',
                                            order_param_direction: sort1 ? sort1 : "DESC",
                                            search: searchValue,
                                            on_trash: isDelete,
                                            page: 1,
                                            limit: 100,
                                            executor: selectedExecutor?.length > 0 ? selectedExecutor : []
                                          }}
                                          actualId={actualId}
                                          setActualId={setActualId}
                                          updateId={updateId}
                                          setUpdateId={setUpdateId}
                                          setIsUpdateTotal={setIsUpdateTotal}
                                          isUpdateTotal={isUpdateTotal}
                                          refsTotal={refsTotal}
                                          fetchAllColumns={() => { fetchAllColumns(false, +taskId) }}
                                          refContainer={refContainer}
                                          setGeneralTotal={setGeneralTotal}
                                          setCountCol={setCountCol}
                                          columns={columns}
                                          searchValue={searchValue}
                                          isVisibleCheckbox={isVisibleCheckbox}
                                          listPrint={listPrint}
                                          setListPrint={(e) => setListPrint(e)}
                                          // Обновление колонок 
                                          isUpdateDataColumnList={isUpdateDataColumn}
                                          setIsUpdateColumn={setIsUpdateColumn}
                                          task
                                        />
                                      </div>
                                    }
                                  </Fragment>
                                ))}
                          </>
                        )}
                      </div>
                    )}

                    {selectView == 'Table' &&
                      <TableBox
                        {...tableProps}
                        ref={paginatorRef}
                        paginator={true}
                        fetchCallback={fetchTableData}
                        onAction={onActionTable}
                      />
                    }
                  </div>
                </div>

                {isVisible && selectView !== 'Table' && (
                  <div
                    className="scrollbar"
                    ref={refScrollbar}
                    onScroll={(e) => {
                      if (refContainer.current) {
                        refContainer.current.scrollLeft = e.target.scrollLeft;
                      }
                      scrollBottom();
                    }}
                    style={{
                      height: '16px',
                      position: 'fixed',
                      bottom: 0,
                      left: leftPosition + 'px',
                      maxWidth: widthTaskList + 'px',
                      minWidth: widthTaskList + 'px',
                      width: '100%',
                      overflowX: isBlockKey ? 'hidden' : 'auto',
                      overflowY: 'hidden',
                    }}
                  >
                    <div
                      style={{
                        minWidth: widtContainer,
                        maxWidth: widtContainer,
                      }}
                    ></div>
                  </div>
                )}
              </>
            }
          />

          {tokenWiki && <Route
            path={`${taskId || eventId}/wiki/*`}
            element={
              <Main
                isShowMain={false}
                readonly={false}
                activeLang={'ru'}
                pathBread={`tasks/task-list/${taskId || eventId}`}
                pathsWebName={pathsWebName}
                setPathsWebName={(e) => setPathsWebName(e)}
                paths={paths}
                setPaths={setPaths}
                token={tokenWiki}
                setToken={setTokenWiki}
                wikiId={wikiId}
              />
            } />}

          {<Route
            path={`${taskId || eventId}/wiki/*`}
            element={
              <NotActive />} />}

          <Route
            path={`${taskId || eventId}/files/*`}
            element={fileId ?
              <MainDirectory
                isShowMain={false}
                mainPath={`/tasks/task-list/${taskId || eventId}/files`}
                activeLang={'ru'}
                pathBread={`tasks/task-list/${taskId || eventId}/files`}
                directory={true}
                fileId={fileId}
                projectId={taskId}
              />
              :
              <NotActive />
            } />

          <Route
            path={`${taskId || eventId}/task_list/*`}
            element={<CheckList
              title={projectName}
              idTable={idTable}
              authorEmail={localStorage.getItem('email')}
              style={{
                maxWidth: '1000px',
                background: '#fff',
                padding: '24px',
                borderRadius: '8px'
              }}
            />} />
        </Routes>
      </div>
    </>
  );
};

// Обёртка: при смене проекта (первый сегмент пути) компонент монтируется заново,
// весь state сбрасывается, как после перезагрузки, но без неё
const TaskList = (props) => {
  const projectKey = useParams()['*']?.split('/')[0];
  return <TaskListInner key={projectKey} {...props} />;
};

export { TaskList };
